import { render, staticRenderFns } from "./CardBaseS.vue?vue&type=template&id=25ee05d7&scoped=true&"
import script from "./CardBaseS.vue?vue&type=script&lang=js&"
export * from "./CardBaseS.vue?vue&type=script&lang=js&"
import style0 from "./CardBaseS.vue?vue&type=style&index=0&id=25ee05d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ee05d7",
  null
  
)

export default component.exports